var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7574 15.2197L29.5303 17.9926C29.8232 18.2855 29.8232 18.7604 29.5303 19.0533L26.7574 21.8263C26.4645 22.1192 25.9896 22.1192 25.6967 21.8263C25.4038 21.5334 25.4038 21.0585 25.6967 20.7656L27.1893 19.273H22C21.5858 19.273 21.25 18.9372 21.25 18.523C21.25 18.1088 21.5858 17.773 22 17.773H27.1893L25.6967 16.2803C25.4038 15.9874 25.4038 15.5126 25.6967 15.2197C25.9896 14.9268 26.4645 14.9268 26.7574 15.2197Z",
    fill: "#6D757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4716 12.3076C10.2801 11.235 11.1048 10.25 12.1944 10.25H20C20.9665 10.25 21.75 11.0335 21.75 12V15C21.75 15.4142 21.4142 15.75 21 15.75C20.5858 15.75 20.25 15.4142 20.25 15V12C20.25 11.8619 20.1381 11.75 20 11.75H12.1944C12.0387 11.75 11.9209 11.8907 11.9483 12.0439L14.0911 24.0439C14.1124 24.1632 14.2161 24.25 14.3373 24.25H20C20.1381 24.25 20.25 24.1381 20.25 24V22C20.25 21.5858 20.5858 21.25 21 21.25C21.4142 21.25 21.75 21.5858 21.75 22V24C21.75 24.9665 20.9665 25.75 20 25.75H14.3373C13.4894 25.75 12.7635 25.1423 12.6145 24.3076L10.4716 12.3076Z",
    fill: "#6D757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color",
    d: "M11 24.5577V12.1103C11 11.2667 11.9803 10.8021 12.6332 11.3363L16.1332 14.2C16.3654 14.3899 16.5 14.674 16.5 14.9739V27.7395C16.5 28.6076 15.4697 29.0634 14.8273 28.4794L11.3273 25.2976C11.1189 25.1081 11 24.8394 11 24.5577Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "icon-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1583 11.9168C11.9951 11.7832 11.75 11.8993 11.75 12.1103V24.5576C11.75 24.6281 11.7797 24.6952 11.8318 24.7426L15.3318 27.9244C15.4924 28.0704 15.75 27.9565 15.75 27.7395V14.9739C15.75 14.8989 15.7163 14.8279 15.6583 14.7804L12.1583 11.9168ZM10.25 12.1103C10.25 10.6339 11.9655 9.82095 13.1082 10.7558L16.6082 13.6195C17.0144 13.9518 17.25 14.449 17.25 14.9739V27.7395C17.25 29.2587 15.447 30.0563 14.3228 29.0344L14.8273 28.4794L14.3228 29.0344L10.8228 25.8525C10.458 25.5209 10.25 25.0507 10.25 24.5576V12.1103Z",
    fill: "#6D757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccLogout);
export default __webpack_public_path__ + "static/media/icon-acc-logout.6a152ff391b44c18a2c52240d01a2a34.svg";
export { ForwardRef as ReactComponent };